import script from "./AboutPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutPanel.vue?vue&type=script&setup=true&lang=js"

import "./AboutPanel.vue?vue&type=style&index=0&id=3d0d96c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d0d96c6"]])

export default __exports__